// c:/Users/himan/intern/another/tele_frontend_2/src/views/admin/default/components/ComplexTable.js
// Real
import React, { useEffect, useMemo, useRef, useState } from "react";
import useSocket from "hooks/useSocket";
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button,
    Flex,
    IconButton,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Select,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogCloseButton,
} from "components-lib";
import { Receipt, RotateCcw as RepeatIcon } from "lucide-react";
import { FiEdit } from "react-icons/fi";
import { useGlobalFilter, usePagination, useSortBy, useTable, } from "react-table";
import Card from "../../../../components/card/Card";
import BookAppointmentModal from "./BookAppointmentModal";

import LabTestsModal from "views/admin/doctors/patient-details/components/LabTestsModal.jsx";
import ParametersModal from "../../appointments/ParametersModal";
import PastAppoinmentModal from "views/admin/doctors/patient-details/components/PastAppoinmentModal.jsx";
import PaymentReceiptModal from "./PaymentReceiptModal";
import EditAppointmentModal from "views/admin/appointments/EditAppointmentModal";

// NEW: import EditPatientForm
import EditPatientForm from "views/admin/doctors/EditPatientForm";

import { axiosInstance, getAuthHeaders } from "config/api";

// In-memory cache keyed by appointment_id. This persists for the lifetime of the page
// (i.e. until a hard reload). We store the fetched bill object (first bill from API).
const billsByAppointmentCache = new Map();

export default function ComplexTable({
    columnsData,
    tableData,
    setTableDataComplex,
    onRowClick,
    onPastAppointmentsClick,
    isAppointment = false,
    doctorId,
    onAppointmentStatusUpdate,
    onPaymentStatusUpdate,
}) {
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const socketRef = useRef(null);
    // Shared socket helpers from SocketProvider
    const { emit, subscribe, connected } = useSocket();
    // const [isOpen, setIsOpen] = useState(false);
    const [isLabOpen, setIsLabOpen] = useState(false);
    const [isParametersOpen, setIsParametersOpen] = useState(false);
    const [isPastAppointmentsOpen, setIsPastAppointmentsOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [selectedAppointmentData, setSelectedAppointmentData] = useState(null);
    const [billingSummary, setBillingSummary] = useState(null);
    const {
        isOpen: isPaymentModalOpen,
        onOpen: onPaymentModalOpen,
        onClose: onPaymentModalClose,
    } = useDisclosure();
    const [selectedPaymentRow, setSelectedPaymentRow] = useState(null);
    const [filters, setFilters] = useState({
        doctor: "",
        paymentStatus: "",
        appointmentDate: "",
    });
    const [newAppointmentData, setNewAppointmentData] = useState({
        patient: "",
        doctor: "",
        date: "",
        time: "",
        notes: "",
        parameters: {
            height: "",
            weight: "",
            temperature: "",
            bloodPressure: "",
            sugarLevel: "",
            respirationRate: "",
            pulseRate: "",
        },
        bill: 0,
    });

    // NEW: states for editing patient overlay
    const [isEditPatientOpen, setIsEditPatientOpen] = useState(false);
    const [selectedPatientForEdit, setSelectedPatientForEdit] = useState(null);

    // NEW: states for prescription modal
    const {
        isOpen: isPrescriptionModalOpen,
        onOpen: onPrescriptionModalOpen,
        onClose: onPrescriptionModalClose,
    } = useDisclosure();
    const [prescriptionUrl, setPrescriptionUrl] = useState(null);
    const [prescriptionLoading, setPrescriptionLoading] = useState(false);

    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    // Info modal for showing messages like "No invoice available" / "No receipt available"
    const {
        isOpen: isInfoOpen,
        onOpen: onInfoOpen,
        onClose: onInfoClose,
    } = useDisclosure();
    const [modalMessage, setModalMessage] = useState("");

    console.log("parent par hu, doc id fetch hui he: ", doctorId);
    const openModal = () => onOpen();
    const closeModal = () => onClose();
    const openLabModal = () => setIsLabOpen(true);
    const closeLabModal = () => setIsLabOpen(false);
    const openParametersModal = (data) => {
        console.log("Opening ParametersModal with data:", data);
        setSelectedData(data);
        setIsParametersOpen(true);
    };

    const closeParametersModal = () => {
        console.log("Closing ParametersModal");
        setIsParametersOpen(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAppointmentData((prevData) => ({ ...prevData, [name]: value }));
    };

    // const handleStatusChange = (row, newStatus) => {
    //     const currentStatus = String(row.status).toUpperCase().trim();

    //     // Check if trying to toggle between BOOKED and ARRIVED
    //     if (currentStatus === "ARRIVED" && newStatus === "ARRIVED") {
    //         if (
    //             window.confirm("Are you sure you want to change status back to BOOKED?")
    //         ) {
    //             newStatus = "BOOKED";
    //         } else {
    //             return; // User cancelled the status change
    //         }
    //     } else if (currentStatus === "BOOKED" && newStatus === "ARRIVED") {
    //         // Show confirmation for changing from BOOKED to ARRIVED
    //         if (!window.confirm("Mark this appointment as ARRIVED?")) {
    //             return; // User cancelled the status change
    //         }
    //     }

    //     console.log("ComplexTable - Status change initiated:", {
    //         rowId: row.id,
    //         currentStatus: row.status,
    //         nextStatus: newStatus,
    //         apiEndpoint: "/api/appointment/updateApptStatus",
    //         payload: { id: row.id, status: newStatus },
    //         rowData: row,
    //     });

    //     // Only call the parent's onStatusChange if it exists
    //     if (typeof row.onStatusChange === "function") {
    //         console.log("ComplexTable - Calling parent onStatusChange");
    //         row.onStatusChange(row, newStatus);
    //     } else {
    //         console.log("ComplexTable - No parent onStatusChange handler found");
    //     }
    // };

    const handleparametersChange = (e) => {
        const { name, value } = e.target;
        setNewAppointmentData((prevData) => ({
            ...prevData,
            parameters: { ...prevData.parameters, [name]: value },
        }));
    };

    const handleGenerateBill = () => {
        const subtotal = 56.0;
        const discount = 28.0;
        const total = subtotal - discount;

        setBillingSummary({
            subtotal,
            discountCode: "STUDENT",
            discountAmount: discount,
            discountPercentage: 50,
            total,
        });
    };

    const handleBookAppointment = () => {
        closeModal();
    };

    const handleRowClick = (row) => {
        if (onRowClick) {
            onRowClick(row);
        }
    };

    const handleLabTestsClick = (data) => {
        setSelectedData(data);
        openLabModal();
    };

    const handleOpenParametersModal = (data) => {
        console.log("Opening ParametersModal with data:", data);
        setSelectedData(data);
        setIsParametersOpen(true);
    };

    const handleCloseParametersModal = () => {
        console.log("Closing ParametersModal");
        setIsParametersOpen(false);
        setSelectedData(null);
    };

    const handleParametersChange = (updatedParameters) => {
        console.log("Parameters changed:", updatedParameters);
        if (selectedData && selectedData.id) {
            const updatedTableData = tableData.map((item) =>
                item.id === selectedData.id
                    ? { ...item, parameters: updatedParameters }
                    : item,
            );

            if (typeof setTableDataComplex === "function") {
                setTableDataComplex(updatedTableData);
            }
        }
    };

    const handlePastAppointmentsClick = (data) => {
        setSelectedAppointmentData(data);
        setIsPastAppointmentsOpen(true);
    };

    // NEW: Fetch prescription by appointment ID
    const handlePrescriptionClick = async (appointmentData) => {
        // alert("Fetching prescription for appointment ID: " + appointmentData.id);
        if (appointmentData?.id) {
            // Fetch prescription if not directly available
            setPrescriptionLoading(true);
            try {
                const response = await axiosInstance.get(
                    `/api/prescription/getPrescriptions?appointment_id=${appointmentData.id}`
                );
                if (response.data?.data && response.data.data.length > 0) {
                    const prescriptionUrl = response.data.data[0]?.prescription_url;
                    if (prescriptionUrl) {
                        setPrescriptionUrl(prescriptionUrl);
                        onPrescriptionModalOpen();
                    } else {
                        toast({
                            title: "No Prescription",
                            description: "Prescription PDF not found for this appointment.",
                            status: "warning",
                            duration: 3,
                            isClosable: true,
                        });
                    }
                } else {
                    toast({
                        title: "No Prescription",
                        description: "No prescription found for this appointment.",
                        status: "warning",
                        duration: 3,
                        isClosable: true,
                    });
                }
            } catch (error) {
                console.error("Error fetching prescription:", error);
                toast({
                    title: "Error",
                    description: "Failed to fetch prescription. Please try again.",
                    status: "error",
                    duration: 3,
                    isClosable: true,
                });
            } finally {
                setPrescriptionLoading(false);
            }
        }
    };

    // NEW: Handle prescription download
    const handleDownloadPrescription = () => {
        if (prescriptionUrl) {
            const link = document.createElement("a");
            link.href = prescriptionUrl;
            link.download = "prescription.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    // NEW: Handle prescription print
    const handlePrintPrescription = () => {
        if (prescriptionUrl) {
            const printWindow = window.open(prescriptionUrl);
            printWindow.onload = () => {
                printWindow.focus();
                printWindow.print();

            };

        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const filteredData = useMemo(() => {
        console.log("The filters are: ", filters);
        return tableData.filter((row) => {
            if (filters) {
                return (
                    (filters.doctor === "" || row.doctor === filters.doctor) &&
                    (filters.paymentStatus === "" ||
                        row.paymentStatus === filters.paymentStatus) &&
                    (filters.appointmentDate === "" ||
                        row.date === filters.appointmentDate)
                );
            }
        });
    }, [filters, tableData]);

    // Enhance columns to inject handleStatusChange for STATUS
    const enhancedColumns = useMemo(() => {
        return columnsData.map((col) => {
            if (col.Header === "STATUS") {
                return {
                    ...col, // Implement Websocket here
                    handleStatusChange: async (row, newStatus) => {
                        try {
                            const normalizedStatus = String(row.status).toUpperCase().trim();

                            // Allow BOOKED <-> ARRIVED transitions via button click
                            if (!["BOOKED", "ARRIVED"].includes(normalizedStatus)) {
                                return; // Don't allow button clicks for other statuses
                            }

                            console.log("Status change initiated:", {
                                rowId: row.id,
                                currentStatus: row.status,
                                newStatus,
                            });

                            // For ARRIVED -> BOOKED, we'll handle the confirmation in handleStatusChange
                            const response = await axiosInstance.post(
                                "/api/appointment/updateApptStatus",
                                {
                                    id: row.id,
                                    status: newStatus,
                                },
                            );

                            if (response.data) {
                                // If the parent component provided a way to refresh data, use it
                                if (typeof setTableDataComplex === "function") {
                                    setTableDataComplex((prevData) =>
                                        prevData.map((item) =>
                                            item.id === row.id
                                                ? { ...item, status: newStatus }
                                                : item,
                                        ),
                                    );
                                }

                                // Emit socket event to inform backend (backend should broadcast authoritative update)
                                try {
                                    if (typeof emit === "function") {
                                        emit("appointment.status.change", {
                                            appointment_id: row.id,
                                            status: newStatus,
                                        });
                                    }
                                } catch (e) {
                                    console.warn("Socket emit failed:", e);
                                }
                            }
                        } catch (error) {
                            console.error("Error updating status:", error);
                        }
                    },
                };
            }
            if (col.Header === "PAYMENT ACTION") {
            }
            return col;
        });
    }, [columnsData, setTableDataComplex]);

    const columns = useMemo(() => enhancedColumns, [enhancedColumns]);

    // Attach helpful handlers (edit/delete/prescription/book) to each row so column cells
    // can call them (columns are authored to call `row.original.onEdit` / `row.original.onDelete`).
    const data = useMemo(() => {
        return filteredData.map((row) => ({
            ...row,
            // Provide row-specific functions that capture the row
            onEdit: () => handleOpenEditPatient(row),
            onDelete: () => handleDeletePatient(row),
            handleDelete: () => handleDeletePatient(row),
            onPrescriptionClick: (url) => handlePrescriptionClick(url, row),
            book_appointments: (isEmergency) => {
                if (typeof row?.book_appointments === "function") {
                    // Preserve original behaviour if provided by parent
                    return row.book_appointments(isEmergency);
                }
                // else call local book handler
                handleBookAppointment(row);
            },
        }));
    }, [filteredData]);

    const tableInstance = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 4 },
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = tableInstance;

    // Add logging for column data
    useEffect(() => {
        console.log("🔥 === COMPLEX TABLE DEBUG ===");
        console.log("🔥 ComplexTable - Current columns:", columnsData);
        console.log("🔥 ComplexTable - Current table data:", tableData);
        console.log("🔥 ComplexTable - Table data length:", tableData?.length);
        console.log("🔥 ComplexTable - Table data type:", typeof tableData);
        console.log(
            "🔥 ComplexTable - Is table data array:",
            Array.isArray(tableData),
        );

        if (tableData && Array.isArray(tableData) && tableData.length > 0) {
            console.log("🔥 ComplexTable - First row sample:", tableData[0]);
            console.log(
                "🔥 ComplexTable - All row keys:",
                Object.keys(tableData[0] || {}),
            );
        }
        console.log("🔥 === END COMPLEX TABLE DEBUG ===");
    }, [columnsData, tableData]);

    // Removed unused textColor variable to fix lint warning
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

    const handleBookAppointmentClick = (data) => {
        console.log("Booking appointment for patient:", data);
        setSelectedData(data);
        setNewAppointmentData({
            patientId: data.id || data.patient_id || "",
            patientName: data.name || "",
            patientGender: data.gender || "",
            patientAge: data.age || "",
            phone_no: data.phoneNumber || data.phone_no || "",
            appointmentDate: new Date().toISOString().split("T")[0],
            doctorId: "",
            appointmentTime: "",
            appointmentType: "",
            serviceId: "",
            labReferred: "",
        });
        openModal();
    };

    // SOCKET IMPLEMENTATION
    // Subscribe to server broadcasts and keep table rows in sync.
    // We rely on the shared SocketProvider and `useSocket` hook.
    useEffect(() => {
        // Only proceed if subscribe function is available.
        if (typeof subscribe !== "function") {
            // Nothing to subscribe with
            return;
        }

        // appointment.status.updated handler (existing behavior)
        const apptHandler = (payload) => {
            // Expected payload shape:
            // { appointment_id, status, updated_at, type, changed_by }
            if (!payload || !payload.appointment_id) return;
            // alert(`Appointment ${payload.appointment_id} status updated`);

            // If parent provided a setter function, update parent-managed table data.
            if (typeof setTableDataComplex === "function") {
                setTableDataComplex((prev) =>
                    Array.isArray(prev)
                        ? prev.map((item) => {
                            const itemId =
                                item.id ?? item.appointment_id ?? item.appointmentId;
                            if (String(itemId) === String(payload.appointment_id)) {
                                return { ...item, status: payload.status };
                            }
                            return item;
                        })
                        : prev,
                );
                return;
            }

            // Fallback: if parent provided a callback to receive status updates, forward payload.
            if (typeof onAppointmentStatusUpdate === "function") {
                try {
                    onAppointmentStatusUpdate(payload);
                } catch (e) {
                    console.warn("onAppointmentStatusUpdate handler error:", e);
                }
            }
        };

        // payment.status.update handler (new)
        const paymentHandler = (payload) => {
            // Expected payload shape:
            // { appointment_id, status: "PAID"|"PENDING"|..., updated_at, type, changed_by, receipt }
            console.log("Payment status updated", payload);
            // if (!payload || !payload.appointment_id) return;
            // Normalize values
            const apptId = payload.appointment_id;
            const status =
                payload.status ??
                (payload.type === "payment_status_update" ? "PAID" : null);
            const receipt = payload.receipt ?? payload.payment_receipt ?? null;
            const updatedAt = payload.updated_at ?? new Date().toISOString();

            // If parent provided a setter function, update parent-managed table data.
            if (typeof setTableDataComplex === "function") {
                setTableDataComplex((prev) =>
                    Array.isArray(prev)
                        ? prev.map((item) => {
                            const itemId =
                                item.id ?? item.appointment_id ?? item.appointmentId;
                            if (String(itemId) === String(apptId)) {
                                // Update payment-related fields while preserving existing data
                                const next = { ...item };
                                // Use a conservative normalization: set payment_action/payment_status/story fields
                                if (status) {
                                    // keep casing consistent with existing UI checks (some code expects "Paid" etc.)
                                    // but store the raw status as provided as well.
                                    next.payment_action =
                                        String(status).toLowerCase() === "paid" ? "Paid" : status;
                                    next.payment_status = status;
                                }
                                if (receipt) {
                                    // prefer arrays if existing field uses *_urls; otherwise set single receipt field
                                    if (
                                        item.payment_receipt_urls &&
                                        Array.isArray(item.payment_receipt_urls)
                                    ) {
                                        // prepend if not duplicate
                                        const exists =
                                            item.payment_receipt_urls.includes(receipt);
                                        next.payment_receipt_urls = exists
                                            ? item.payment_receipt_urls
                                            : [receipt, ...item.payment_receipt_urls];
                                    } else if (
                                        item.payment_receipt &&
                                        item.payment_receipt !== receipt
                                    ) {
                                        next.payment_receipt_urls = [
                                            receipt,
                                            item.payment_receipt,
                                        ];
                                        next.payment_receipt = receipt;
                                    } else {
                                        next.payment_receipt = receipt;
                                    }
                                }
                                // set/update payment_date if available
                                next.payment_date = updatedAt;
                                return next;
                            }
                            return item;
                        })
                        : prev,
                );
                return;
            }

            // If the parent provided a payment-specific callback, notify it.
            if (typeof onPaymentStatusUpdate === "function") {
                try {
                    onPaymentStatusUpdate(payload);
                } catch (e) {
                    console.warn("onPaymentStatusUpdate handler error:", e);
                }
            }
        };

        // Subscribe to both appointment and payment broadcasts.
        const unsubscribeAppt = subscribe(
            "appointment.status.updated",
            apptHandler,
        );
        const unsubscribePayment = subscribe(
            "payment.status.updated",
            paymentHandler,
        );

        return () => {
            try {
                if (typeof unsubscribeAppt === "function") unsubscribeAppt();
            } catch (e) {
                // ignore
            }
            try {
                if (typeof unsubscribePayment === "function") unsubscribePayment();
            } catch (e) {
                // ignore
            }
        };
    }, [
        subscribe,
        setTableDataComplex,
        onAppointmentStatusUpdate,
        onPaymentStatusUpdate,
    ]);

    // payment.status subscription consolidated into the main socket useEffect above

    // File preview overlay (integrated, open by calling openFilePreview(filenameOrUrl))
    const [isFilePreviewOpen, setIsFilePreviewOpen] = useState(false);
    const [filePreviewUrl, setFilePreviewUrl] = useState(null);
    const [filePreviewExt, setFilePreviewExt] = useState(null);

    // NEW: receipt list modal state
    const {
        isOpen: isReceiptListOpen,
        onOpen: onReceiptListOpen,
        onClose: onReceiptListClose,
    } = useDisclosure();
    const [receiptListUrls, setReceiptListUrls] = useState([]);

    // Public opener - call this with a filename or a full URL to open the overlay.
    // If a plain filename is passed (no protocol, no leading slash) it will be treated
    // as relative to /uploads/<filename>. Adjust this logic if your files live elsewhere.
    const openFilePreview = (fileOrUrl) => {
        if (!fileOrUrl) {
            toast({
                title: "No file URL provided",
                status: "warning",
                duration: 2500,
                isClosable: true,
            });
            return;
        }

        let url = String(fileOrUrl).trim();
        // if not absolute url and not root-relative, assume /uploads/<file>
        if (!/^https?:\/\//i.test(url) && !url.startsWith("/")) {
            url = `/uploads/${url}`;
        }

        console.log("openFilePreview - resolved URL:", url);
        const ext = url.split(".").pop().toLowerCase().split(/#|\?/)[0];
        setFilePreviewUrl(url);
        setFilePreviewExt(ext);
        setIsFilePreviewOpen(true);
    };

    // Backwards-compatible alias used in this file
    const handleBillsFile = openFilePreview;

    const closeFilePreview = () => {
        setIsFilePreviewOpen(false);
        setFilePreviewUrl(null);
        setFilePreviewExt(null);
    };

    // Small helper to build safe url for embedding
    const buildSafeUrl = (u) => String(u).replace(/"/g, "%22");

    // NEW: helper to normalize receipt URLs to array
    const parseReceiptUrls = (val) => {
        if (!val) return [];
        if (Array.isArray(val))
            return val
                .map(String)
                .map((s) => s.trim())
                .filter(Boolean);
        if (typeof val === "string") {
            return val
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);
        }
        return [];
    };

    // NEW: helper to fetch bill by appointment and cache it
    const fetchBillByAppointment = async (appointmentId) => {
        if (!appointmentId) return null;
        const key = String(appointmentId);
        if (billsByAppointmentCache.has(key)) {
            return billsByAppointmentCache.get(key);
        }
        try {
            const response = await axiosInstance.get("/api/bills/byAppointment", {
                params: { appointment_id: appointmentId },
            });
            const bill = response?.data?.bills?.[0] ?? null;
            if (bill) {
                billsByAppointmentCache.set(key, bill);
                // update UI table data so the fetched urls/invoice appear in the row and persist while page is loaded
                if (typeof setTableDataComplex === "function") {
                    setTableDataComplex((prev) =>
                        Array.isArray(prev)
                            ? prev.map((r) => {
                                const rId = r.appointment_id ?? r.id ?? r.appointmentId;
                                if (String(rId) === key) {
                                    return {
                                        ...r,
                                        bill_invoice: bill.bill_invoice ?? r.bill_invoice,
                                        payment_receipt_urls:
                                            bill.payment_receipt_urls ?? r.payment_receipt_urls,
                                    };
                                }
                                return r;
                            })
                            : prev,
                    );
                }
            }
            return bill;
        } catch (err) {
            console.error("Error fetching bill by appointment:", err);
            return null;
        }
    };

    // NEW: flush helpers to clear cached bills and receipts
    const handleFlushReceiptsCache = (columnOnly = false) => {
        // Clear the in-memory bills cache entirely
        try {
            billsByAppointmentCache.clear();
        } catch (err) {
            console.warn("Error clearing billsByAppointmentCache:", err);
        }

        // Clear receipt fields in table data if parent setter available
        if (typeof setTableDataComplex === "function") {
            setTableDataComplex((prev) =>
                Array.isArray(prev)
                    ? prev.map((r) => {
                        const rn = { ...r };
                        // remove any receipt references
                        delete rn.payment_receipt;
                        delete rn.payment_receipt_urls;
                        return rn;
                    })
                    : prev,
            );
        }

        setReceiptListUrls([]);
        // toast({ title: "Receipt cache cleared", status: "info", duration: 2000, isClosable: true });
    };

    const handleFlushInvoicesCache = () => {
        try {
            billsByAppointmentCache.clear();
        } catch (err) {
            console.warn("Error clearing billsByAppointmentCache:", err);
        }

        // Clear invoice fields in table data if parent setter available
        if (typeof setTableDataComplex === "function") {
            setTableDataComplex((prev) =>
                Array.isArray(prev)
                    ? prev.map((r) => {
                        const rn = { ...r };
                        // remove any invoice references
                        delete rn.bill_invoice;
                        delete rn.invoice;
                        delete rn.invoice_url;
                        return rn;
                    })
                    : prev,
            );
        }

        // toast({ title: "Invoice cache cleared", status: "info", duration: 2000, isClosable: true });
    };

    // Accept either a raw URL/string OR the row object (preferred). When passed a row object,
    // try to fetch the bill by appointment_id (if necessary) and then open the receipts list.
    const handleOpenReceiptList = async (rowOrVal) => {
        // If caller passed a primitive/string, keep original behavior
        if (!rowOrVal || typeof rowOrVal === "string") {
            const urls = parseReceiptUrls(rowOrVal);
            if (urls.length === 0) {
                setModalMessage("No receipt available");
                onInfoOpen();
                return;
            }
            if (urls.length === 1) {
                handleBillsFile(urls[0]);
                return;
            }
            setReceiptListUrls(urls);
            onReceiptListOpen();
            return;
        }

        // Otherwise expect a row object
        const appointmentId =
            rowOrVal.appointment_id ?? rowOrVal.id ?? rowOrVal.appointmentId;
        let bill = null;
        if (appointmentId) {
            bill = await fetchBillByAppointment(appointmentId);
        }

        const raw =
            bill?.payment_receipt_urls ??
            rowOrVal.payment_receipt_urls ??
            rowOrVal.payment_receipt ??
            rowOrVal.payment_receipt_urls;

        const urls = parseReceiptUrls(raw);
        if (urls.length === 0) {
            setModalMessage("No receipt available");
            onInfoOpen();
            return;
        }
        if (urls.length === 1) {
            handleBillsFile(urls[0]);
            return;
        }
        setReceiptListUrls(urls);
        onReceiptListOpen();
    };

    // Helper to open invoice for a given row (fetches bill if needed and then opens preview)
    const handleOpenInvoiceForRow = async (row) => {
        if (!row) {
            setModalMessage("No invoice available");
            onInfoOpen();
            return;
        }
        const appointmentId = row.appointment_id ?? row.id ?? row.appointmentId;
        let bill = null;
        if (appointmentId) {
            bill = await fetchBillByAppointment(appointmentId);
        }
        const invoiceUrl =
            bill?.bill_invoice ??
            row?.bill_invoice ??
            row?.invoice_url ??
            row?.invoice;
        if (!invoiceUrl) {
            setModalMessage("No invoice available");
            onInfoOpen();
            return;
        }
        openFilePreview(invoiceUrl);
    };

    // File preview overlay component
    const FilePreviewOverlay = () => {
        if (!isFilePreviewOpen) return null;

        const url = filePreviewUrl || "";
        const ext = (filePreviewExt || "").toLowerCase();
        const safe = buildSafeUrl(url);
        const fileName = url.split("/").pop() || "file";

        const isImage = /^(jpg|jpeg|png|gif|svg|webp|bmp)$/.test(ext);
        const isPdf = ext === "pdf";
        const isText = /^(txt|json|csv|xml|html)$/.test(ext);

        const openPrint = (e) => {
            // If image, open minimal window with image and print
            if (isImage) {
                const w = window.open("");
                if (w) {
                    w.document.write(
                        `<html><head><title>Print</title></head><body style="margin:0"><img src="${url}" style="max-width:100%;height:auto;"/></body></html>`,
                    );
                    w.document.close();
                    w.focus();
                    // try to print after a small delay to ensure image loads
                    setTimeout(() => {
                        try {
                            w.print();
                        } catch (err) {
                            console.error("Print error:", err);
                        }
                    }, 300);
                } else {
                    // fallback: open in new tab
                    window.open(url, "_blank", "noopener,noreferrer");
                }
                return;
            }

            // For PDFs / text / other: try printing via hidden iframe
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
            iframe.src = url;
            iframe.onload = () => {
                try {
                    // try accessing contentWindow (works for same-origin)
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                } catch (err) {
                    console.warn(
                        "Iframe print failed (likely cross-origin). Opening in new tab.",
                        err,
                    );
                    // fallback: open new tab so user can print manually
                    window.open(url, "_blank", "noopener,noreferrer");
                } finally {
                    setTimeout(() => {
                        try {
                            iframe.remove();
                        } catch (e) {
                        }
                    }, 1000);
                }
            };
            document.body.appendChild(iframe);
        };

        const downloadFile = (e) => {
            e.stopPropagation();
            if (!url) return;
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
        };

        return (
            <>
                <Box
                    onClick={closeFilePreview}
                    position="fixed"
                    inset={0}
                    bg="rgba(0,0,0,0.4)"
                    zIndex="overlay"
                />
                <Box
                    position="fixed"
                    right={0}
                    top={0}
                    height="100vh"
                    width={["100%", "100%", "70%", "60%"]}
                    maxWidth="1100px"
                    bg="white"
                    zIndex="overlay"
                    display="flex"
                    flexDirection="column"
                >
                    <Flex
                        align="center"
                        justify="space-between"
                        px={4}
                        py={3}
                        borderBottom="1px solid"
                        borderColor="gray.100"
                    >
                        <Text fontWeight="600">Preview — {fileName}</Text>
                        <Flex gap={2} align="center">
                            <Button
                                size="sm"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    // Print handler
                                    if (!url) return;
                                    openPrint(e);
                                }}
                                isDisabled={!url}
                            >
                                Print
                            </Button>
                            <Button size="sm" onClick={downloadFile} isDisabled={!url}>
                                Download
                            </Button>
                            <Button size="sm" colorScheme="red" onClick={closeFilePreview}>
                                Close
                            </Button>
                        </Flex>
                    </Flex>

                    <Box
                        flex="1"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        p={3}
                        overflow="auto"
                    >
                        {!url ? (
                            <Text>No file to preview</Text>
                        ) : isImage ? (
                            <Box as="div" width="100%" textAlign="center">
                                <img
                                    src={url}
                                    alt="preview"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "calc(100vh - 140px)",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>
                        ) : isPdf || isText ? (
                            <iframe
                                title="file-preview"
                                src={safe}
                                style={{
                                    width: "100%",
                                    height: "calc(100vh - 140px)",
                                    border: "none",
                                }}
                            />
                        ) : (
                            // fallback: try iframe and provide open link
                            <Box width="100%">
                                <iframe
                                    title="file-preview-fallback"
                                    src={safe}
                                    style={{
                                        width: "100%",
                                        height: "calc(100vh - 200px)",
                                        border: "none",
                                    }}
                                />
                                <Flex mt={3} justify="center">
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            padding: "8px 12px",
                                            background: "#2b6cb0",
                                            color: "#fff",
                                            borderRadius: 6,
                                            textDecoration: "none",
                                        }}
                                    >
                                        Open in new tab
                                    </a>
                                </Flex>
                            </Box>
                        )}
                    </Box>
                </Box>
            </>
        );
    };

    // NEW: Modal listing receipts grouped into Normal and Refund sections
    const ReceiptListModal = () => {
        if (!isReceiptListOpen) return null;

        // classify receipts: refund if filename contains "refund" or "refund_receipts_" (case-insensitive)
        const isRefundFile = (u) => {
            const name = (String(u).split("/").pop() || "").toLowerCase();
            return name.includes("refund") || name.includes("refund_receipts_") || /refund/i.test(u);
        };

        const refundReceipts = receiptListUrls.filter(isRefundFile);
        const normalReceipts = receiptListUrls.filter((u) => !isRefundFile(u));

        const renderList = (list, isRefundSection = false) => {
            if (!list || list.length === 0) {
                return (
                    <Text color="gray.500" fontSize="sm" mt={2}>
                        No files
                    </Text>
                );
            }

            return list.map((u, idx) => {
                const name = u.split("/").pop() || `File ${idx + 1}`;
                return (
                    <Flex
                        key={`${u}-${idx}`}
                        align="center"
                        justify="space-between"
                        p={3}
                        borderRadius="md"
                        border="1px solid"
                        borderColor={isRefundSection ? "red.100" : "gray.100"}
                        mb={2}
                    >
                        <Flex align="center" minWidth={0} gap={3} flex="1">
                            <Text
                                flex="1"
                                minWidth={0}
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                color={isRefundSection ? "red.600" : "inherit"}
                                fontWeight={isRefundSection ? "600" : "500"}
                            >
                                {name}
                            </Text>

                            {isRefundSection && (
                                <Box fontSize="xs" px={2} py={1} bg="red.50" color="red.600" borderRadius="md">
                                    Refund
                                </Box>
                            )}
                        </Flex>

                        <Flex gap={2} ml={3}>
                            <Button
                                size="sm"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    onReceiptListClose();
                                    handleBillsFile(u);
                                }}
                            >
                                Open
                            </Button>
                            <Button
                                as="a"
                                href={u}
                                target="_blank"
                                rel="noopener noreferrer"
                                size="sm"
                                colorScheme={isRefundSection ? "red" : "blue"}
                            >
                                Open in new tab
                            </Button>
                        </Flex>
                    </Flex>
                );
            });
        };

        return (
            <Modal isOpen={isReceiptListOpen} onClose={onReceiptListClose} size="lg" isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Receipts</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Box mb={4}>
                            <Flex justify="space-between" align="center" mb={3}>
                                <Text fontSize="md" fontWeight="600">
                                    Payment Receipts
                                </Text>
                                <Text fontSize="sm" color="gray.500">
                                    {normalReceipts.length} file{normalReceipts.length !== 1 ? "s" : ""}
                                </Text>
                            </Flex>

                            {renderList(normalReceipts, false)}
                        </Box>

                        <Box height="1px" bg="gray.100" my={4} />

                        <Box>
                            <Flex justify="space-between" align="center" mb={3}>
                                <Text fontSize="md" fontWeight="600" color="red.600">
                                    Refund Receipts
                                </Text>
                                <Text fontSize="sm" color="gray.500">
                                    {refundReceipts.length} file{refundReceipts.length !== 1 ? "s" : ""}
                                </Text>
                            </Flex>

                            {renderList(refundReceipts, true)}
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        );
    };

    // Info modal component for showing invoice/receipt messages
    const InfoModal = () => {
        if (!isInfoOpen) return null;
        return (
            <Modal isOpen={isInfoOpen} onClose={onInfoClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontWeight="bold" textAlign={"center"} fontSize={"2xl"}>
                            {modalMessage}
                        </Text>
                    </ModalBody>
                </ModalContent>
            </Modal>
        );
    };

    // NEW: Prescription modal component
    const PrescriptionModal = () => {
        return (
            <Modal isOpen={isPrescriptionModalOpen} onClose={onPrescriptionModalClose} size="6xl" isCentered>
                <ModalOverlay />
                <ModalContent maxH="99vh" display="flex" flexDirection="column">
                    <ModalHeader>Prescription PDF</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody flex="1" overflow="auto" p={4}>
                        {prescriptionLoading ? (
                            <Flex justifyContent="center" alignItems="center" height="100%">
                                <Text>Loading prescription...</Text>
                            </Flex>
                        ) : prescriptionUrl ? (
                            <Box
                                as="iframe"
                                src={prescriptionUrl}
                                width="100%"
                                height="100%"
                                minHeight="600px"
                                border="1px solid #e2e8f0"
                                borderRadius="md"
                                title="Prescription PDF"
                            />
                        ) : (
                            <Flex justifyContent="center" alignItems="center" height="100%">
                                <Text color="gray.500">No prescription available</Text>
                            </Flex>
                        )}
                    </ModalBody>
                    <Flex gap={2} p={4} borderTop="1px solid #e2e8f0" justifyContent="flex-end">
                        <Button
                            colorScheme="blue"
                            isDisabled={!prescriptionUrl}
                            onClick={handleDownloadPrescription}
                        >
                            Download
                        </Button>
                        <Button
                            colorScheme="green"
                            isDisabled={!prescriptionUrl}
                            onClick={handlePrintPrescription}
                        >
                            Print
                        </Button>
                        <Button colorScheme="gray" onClick={onPrescriptionModalClose}>
                            Close
                        </Button>
                    </Flex>
                </ModalContent>
            </Modal>
        );
    };

    // NEW: open edit patient overlay
    const handleOpenEditPatient = (patient) => {
        setSelectedPatientForEdit(patient);
        setIsEditPatientOpen(true);
    };

    const handleCloseEditPatient = () => {
        setIsEditPatientOpen(false);
        setSelectedPatientForEdit(null);
    };

    // Open delete confirmation dialog for a patient (does NOT delete yet)
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [patientToDelete, setPatientToDelete] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const cancelDeleteRef = useRef(null);

    const handleDeletePatient = (patient) => {
        if (!patient) return;
        setPatientToDelete(patient);
        setIsDeleteDialogOpen(true);
    };

    // Confirm deletion (called when user clicks Delete in modal)
    const confirmDeletePatient = async () => {
        if (!patientToDelete) return;

        const id = patientToDelete.patient_id ?? patientToDelete.id;
        const name = patientToDelete.name || "Patient";

        setIsDeleting(true);
        try {
            await axiosInstance.delete(`/api/patients/delete/${id}`, {
                headers: getAuthHeaders(),
            });

            if (typeof setTableDataComplex === "function") {
                setTableDataComplex((prev) => {
                    if (!Array.isArray(prev)) return prev;
                    return prev.filter((r) => (r.patient_id ?? r.id) !== id);
                });
            }

            toast({
                title: "Deleted",
                description: `${name} deleted successfully.`,
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top",
            });

            try {
                window.dispatchEvent(new CustomEvent("refreshPatients"));
            } catch (e) {
                /* ignore */
            }

            setIsDeleteDialogOpen(false);
            setPatientToDelete(null);
        } catch (err) {
            console.error("Error deleting patient:", err);
            toast({
                title: "Error",
                description: err?.response?.data?.message || err?.message || "Failed to delete patient",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top",
            });
        } finally {
            setIsDeleting(false);
        }
    };

    const cancelDelete = () => {
        setIsDeleteDialogOpen(false);
        setPatientToDelete(null);
    };

    const handlePaymentConfirm = (receiptFileName, paymentStatus = "PAID") => {
        if (selectedPaymentRow) {
            const updatedData = tableData.map((row) => {
                const rowId = row.id ?? row.appointment_id;
                const selectedId =
                    selectedPaymentRow?.id ?? selectedPaymentRow?.appointment_id;
                // Bug Fix it will now update the payment status in UI only for the selected row by appt id not by patient id
                if (rowId && selectedId && rowId === selectedId) {
                    return {
                        ...row,
                        // Use the provided paymentStatus (e.g., PAID, PENDING, REFUNDED)
                        payment_action:
                            typeof paymentStatus === "string"
                                ? (String(paymentStatus).toLowerCase() === "paid" ? "Paid" : paymentStatus)
                                : row.payment_action,
                        payment_status: paymentStatus,
                        payment_receipt: receiptFileName,
                        payment_date: new Date().toISOString(),
                    };
                }
                return row;
            });

            // Check if setTableDataComplex is a function before calling it
            if (typeof setTableDataComplex === "function") {
                setTableDataComplex(updatedData);
            } else {
                console.warn(
                    "setTableDataComplex is not a function:",
                    typeof setTableDataComplex,
                );
            }

            // Emit a payment status update over socket so other clients (and the backend)
            // can react to this change in real-time. Payload mirrors the appointment
            // status payload shape used elsewhere with sensible payment fields.
            try {
                if (typeof emit === "function") {
                    // try to derive the user information for changed_by
                    let changed_by = null;
                    try {
                        const userRaw = localStorage.getItem("user");
                        if (userRaw) {
                            const parsed = JSON.parse(userRaw);
                            changed_by = {
                                user_id:
                                    parsed?.userId ?? parsed?.id ?? parsed?.user_id ?? null,
                                role: parsed?.role ?? null,
                            };
                        }
                    } catch (err) {
                        // ignore parsing errors and continue without changed_by
                    }

                    const payload = {
                        appointment_id:
                            selectedPaymentRow?.id ??
                            selectedPaymentRow?.appointment_id ??
                            null,
                        status: paymentStatus || "PAID",
                        updated_at: new Date().toISOString(),
                        type: "payment_status_update",
                        changed_by,
                        receipt: receiptFileName,
                    };

                    emit("payment.status.update", payload);
                }
            } catch (e) {
                console.warn("Socket emit for payment.status.update failed:", e);
            }

            toast({
                title: "Payment confirmed",
                description: `Payment has been marked as received with receipt: ${receiptFileName}`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    // Add this useEffect to log table data changes
    useEffect(() => {
        console.log("ComplexTable - Current table data:", tableData);
    }, [tableData]);

    // DEBUG: detect changes to patient_id / phone number between renders
    useEffect(() => {
        if (!tableData || !Array.isArray(tableData)) return;

        try {
            const prev = JSON.parse(window.__complexTablePrevData || "null");
            const curr = tableData.map((r) => ({
                key: r.id ?? r.patient_id ?? r.appointment_id ?? null,
                patient_id: r.patient_id ?? r.id ?? null,
                phone_no: r.phone_no ?? r.phoneNumber ?? r.phone ?? null,
            }));

            if (prev && Array.isArray(prev)) {
                // build quick lookup maps
                const prevMap = new Map(prev.map((p) => [p.key, p]));
                const changes = [];
                for (const row of curr) {
                    const p = prevMap.get(row.key);
                    if (!p) continue; // new row
                    if (String(p.phone_no) !== String(row.phone_no)) {
                        changes.push({
                            key: row.key,
                            field: "phone_no",
                            before: p.phone_no,
                            after: row.phone_no,
                        });
                    }
                    if (String(p.patient_id) !== String(row.patient_id)) {
                        changes.push({
                            key: row.key,
                            field: "patient_id",
                            before: p.patient_id,
                            after: row.patient_id,
                        });
                    }
                }

                if (changes.length > 0) {
                    console.warn(
                        "ComplexTable DEBUG - detected changes in tableData for phone_no/patient_id:",
                        changes,
                    );
                }
            }

            // persist shallow copy on window for next diff
            window.__complexTablePrevData = JSON.stringify(curr);
        } catch (err) {
            console.error("ComplexTable DEBUG - error diffing tableData:", err);
        }
    }, [tableData]);

    const renderPaymentAction = (cell) => {
        let color =
            cell.value === "Paid"
                ? "green"
                : cell.value === "Pending"
                    ? "red"
                    : cell.value === "REFUND-PENDING"
                        ? "red"
                        : cell.value === "REFUNDED" ? "gray" : "gray";
        return (
            <Button
                colorScheme={color}
                w="100%"
                borderRadius="full"
                fontWeight="bold"
                size="sm"
                onClick={(e) => {
                    e.stopPropagation();
                    if (cell.value === "Pending") {
                        setSelectedPaymentRow(cell.row.original);
                        onPaymentModalOpen();
                    } else if (cell.value === "REFUND-PENDING") {
                        setSelectedPaymentRow(cell.row.original);
                        onPaymentModalOpen();
                    } else if (cell.value === "REFUNDED") {
                        setSelectedPaymentRow(cell.row.original);
                        onPaymentModalOpen();
                    }
                }}
            >
                {cell.value}
            </Button>
        );
    };

    console.log("Parent Component he ye jaha par doc id : ", doctorId);

    // Close handler that also triggers parent refresh (called when PaymentReceiptModal closes)
    const handlePaymentModalCloseWithRefresh = () => {
        // close the chakra disclosure
        onPaymentModalClose();

        // Flush any cached receipts and invoices so UI reflects backend state
        try {
            handleFlushReceiptsCache();
        } catch (err) {
            console.warn("Error flushing receipts cache:", err);
        }

        try {
            handleFlushInvoicesCache();
        } catch (err) {
            console.warn("Error flushing invoices cache:", err);
        }

        // Ask parent to refresh table data if it provides a refresh setter
        // if (typeof setTableDataComplex === "function") {
        //     try {
        //         // If the parent implements a refresh via this prop, call it
        //         setTableDataComplex();
        //         // Give quick feedback
        //         toast({ title: "Refreshing data", status: "info", duration: 1500, isClosable: true });
        //     } catch (err) {
        //         console.error("Error invoking setTableDataComplex:", err);
        //     }
        // }
    };

    return (
        <Card direction="column" w="100%" px="0px" overflowX="auto">
            <Box>
                <Box overflowX="auto" whiteSpace="nowrap" w="100%">
                    <Table
                        variant="simple"
                        color="white" // MISSED Status was not visible Now fixed
                        sx={{
                            tableLayout: "auto",
                            borderCollapse: "separate",
                            borderSpacing: "0",
                            width: "100%",
                            minWidth: "1200px",
                            "& th, & td": {
                                padding: "8px 16px",
                                lineHeight: "1.4",
                                height: "auto",
                                minHeight: "44px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                borderBottom: "1px solid",
                                borderColor: "gray.100",
                                verticalAlign: "middle",
                            },
                            "& tbody tr": {
                                height: "auto",
                                minHeight: "44px",
                                borderBottom: "1px solid",
                                borderColor: "gray.100",
                                "&:hover": {
                                    backgroundColor: "gray.50",
                                },
                            },
                            "& tbody td": {
                                padding: "8px 12px",
                                display: "table-cell",
                                verticalAlign: "middle",
                                fontSize: "14px",
                            },
                            "& thead th": {
                                height: "auto",
                                minHeight: "44px",
                                padding: "12px",
                                borderBottom: "2px solid",
                                borderColor: "gray.200",
                                verticalAlign: "middle",
                                // backgroundColor: "gray.50",
                                fontWeight: "600",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                            },
                        }}
                    >
                        <Thead>
                            {headerGroups.map((headerGroup, index) => (
                                <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                                    {headerGroup.headers.map((column, index) => (
                                        <Th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            key={index}
                                            borderColor={borderColor}
                                            position="sticky"
                                            top={0}
                                            zIndex={1}
                                            textAlign="left"
                                            width={column.width ? `${column.width}px` : "auto"}
                                            minWidth={
                                                column.minWidth ? `${column.minWidth}px` : "auto"
                                            }
                                            maxWidth={
                                                column.maxWidth ? `${column.maxWidth}px` : "auto"
                                            }
                                        >
                                            <Flex
                                                justify="flex-start"
                                                align="center"
                                                color="gray.600"
                                            >
                                                <Flex align="center" gap={2} minWidth={0}>
                                                    {column.render("Header")}
                                                    {/* Refresh button for receipts */}
                                                    {column.Header === "Payment Receipt" && (
                                                        <IconButton
                                                            aria-label="Refresh receipts"
                                                            title="Flush cached receipts"
                                                            size="xs"
                                                            icon={<RepeatIcon />}
                                                            isDisabled={billsByAppointmentCache.size === 0}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                handleFlushReceiptsCache();
                                                            }}
                                                            variant="ghost"
                                                        />
                                                    )}
                                                    {/* Refresh button for invoices */}
                                                    {column.Header === "Bill Invoice" && (
                                                        <IconButton
                                                            aria-label="Refresh invoices"
                                                            title="Flush cached invoices"
                                                            size="xs"
                                                            icon={<RepeatIcon />}
                                                            isDisabled={billsByAppointmentCache.size === 0}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                handleFlushInvoicesCache();
                                                            }}
                                                            variant="ghost"
                                                        />
                                                    )}
                                                </Flex>
                                            </Flex>
                                        </Th>
                                    ))}
                                </Tr>
                            ))}
                        </Thead>
                        <Tbody {...getTableBodyProps()}>
                            {page.map((row, index) => {
                                prepareRow(row);

                                // compute row-level styles for emergency / outside-OPD-emergency / cancelled
                                const isEmergency =
                                    row.original.isEmergency === 1 ||
                                    row.original.is_emergency === 1 ||
                                    row.original.is_emerg === 1;

                                const isOutsideOpdEmergency =
                                    row.original.isOutsideOpdEmergency === 1 ||
                                    row.original.outside_opd_emergency === 1 ||
                                    row.original.outsideOPDEmergency === 1 ||
                                    row.original.is_outside_opd_emergency === 1;

                                const statusNorm = String(
                                    row.original.status || row.original.appointment_status || "",
                                )
                                    .toUpperCase()
                                    .trim();

                                const isCancelled = statusNorm === "CANCELLED";

                                const rowBg =
                                    isEmergency || isOutsideOpdEmergency
                                        ? "rgba(254, 178, 178, 0.5)"
                                        : isCancelled
                                            ? "rgba(226, 232, 240, 0.6)" // faded grey for cancelled
                                            : "transparent";

                                const rowHoverBg =
                                    isEmergency || isOutsideOpdEmergency
                                        ? "rgba(254, 178, 178, 0.7)"
                                        : isCancelled
                                            ? "rgba(226, 232, 240, 0.75)"
                                            : "rgba(0, 0, 0, 0.02)";

                                return (
                                    <Tr
                                        {...row.getRowProps()}
                                        key={index}
                                        onClick={(e) => {
                                            if (e.target.closest("button")) return;
                                            onRowClick && onRowClick(row.original);
                                        }}
                                        style={{
                                            cursor: onRowClick ? "pointer" : "default",
                                            backgroundColor: rowBg,
                                        }}
                                        _hover={{ backgroundColor: rowHoverBg }}
                                    >
                                        {row.cells.map((cell, index) => {
                                            let data = "";

                                            if (cell.column.Header === "BOOK APPOINTMENTS") {
                                                data = (
                                                    <Flex justifyContent="flex-start" alignItems="center">
                                                        <Button
                                                            colorScheme="teal"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleBookAppointmentClick(cell.row.original);
                                                            }}
                                                            size="sm"
                                                            height="32px"
                                                            fontSize="12px"
                                                        >
                                                            Book Appointment
                                                        </Button>
                                                    </Flex>
                                                );
                                            } else if (cell.column.Header === "PAST APPOINTMENTS") {
                                                data = (
                                                    <Flex justifyContent="flex-start" alignItems="center">
                                                        <Button
                                                            colorScheme="blue"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handlePastAppointmentsClick(cell.row.original);
                                                            }}
                                                            size="sm"
                                                            height="32px"
                                                            fontSize="12px"
                                                        >
                                                            View Past Appointments
                                                        </Button>
                                                    </Flex>
                                                );
                                            } else if (cell.column.Header === "LAB TESTS") {
                                                data = (
                                                    <Flex justifyContent="flex-start" alignItems="center">
                                                        <Button
                                                            colorScheme="purple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleLabTestsClick(cell.row.original);
                                                            }}
                                                            size="sm"
                                                            height="32px"
                                                            fontSize="12px"
                                                        >
                                                            View Lab Tests
                                                        </Button>
                                                    </Flex>
                                                );
                                            } else if (cell.column.Header === "parameters") {
                                                // Parameters column
                                                const isArrived =
                                                    String(cell.row.original.status)
                                                        .toUpperCase()
                                                        .trim() === "ARRIVED";
                                                data = (
                                                    <Flex justifyContent="flex-start" alignItems="center">
                                                        {isArrived && (
                                                            <Button
                                                                colorScheme={isArrived ? "orange" : "gray.100"}
                                                                size="sm"
                                                                variant="solid"
                                                                height="32px"
                                                                fontSize="12px"
                                                                isDisabled={!isArrived}
                                                                title={
                                                                    !isArrived
                                                                        ? "parameters can only be added when status is ARRIVED"
                                                                        : "Add parameters"
                                                                }
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleOpenParametersModal(cell.row.original);
                                                                }}
                                                            >
                                                                {isArrived ? "Add" : "Not Available"}
                                                            </Button>
                                                        )}
                                                    </Flex>
                                                );
                                            } else if (cell.column.Header === "PAYMENT ACTION") {
                                                data = (
                                                    <Flex justifyContent="flex-start" alignItems="center">
                                                        {/* Implement Webscoket here  */}
                                                        {renderPaymentAction(cell)}
                                                        {/* WVOASY */}
                                                    </Flex>
                                                );
                                            } else if (cell.column.Header === "STATUS") {
                                                data = cell.render("Cell");
                                            } else if (cell.column.Header === "EDIT") {
                                                // NEW: render edit icon that opens EditPatientForm overlay
                                                data = (
                                                    <Flex justifyContent="flex-start" alignItems="center">
                                                        <IconButton
                                                            icon={<FiEdit size={16} />}
                                                            aria-label="Edit Patient"
                                                            size="sm"
                                                            colorScheme="blue"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                // Provide the full patient object; EditPatientForm can accept id or patient data
                                                                handleOpenEditPatient(cell.row.original);
                                                            }}
                                                        />
                                                    </Flex>
                                                );
                                            } else if (cell.column.Header === "Payment Receipt") {
                                                // Support fetching receipts by appointment_id when not present on row.
                                                const rowData = cell.row.original;
                                                const receiptRaw =
                                                    cell.row.values.payment_receipt_urls ??
                                                    rowData?.payment_receipt_urls ??
                                                    cell.value;
                                                // Consider a row has potential receipts if it already has urls OR it has an appointment_id we can fetch
                                                const hasReceipt =
                                                    parseReceiptUrls(receiptRaw).length > 0 ||
                                                    Boolean(rowData?.appointment_id);

                                                data = (
                                                    <IconButton
                                                        icon={<Receipt size="16px" />}
                                                        aria-label="Open Receipt(s)"
                                                        size="md"
                                                        colorScheme="blue"
                                                        // isDisabled={!hasReceipt}
                                                        onClick={async (e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            // Prefer passing the whole row so handler can fetch & cache if needed
                                                            await handleOpenReceiptList(rowData);
                                                        }}
                                                        title={
                                                            hasReceipt
                                                                ? "Open Receipt"
                                                                : "No receipt available"
                                                        }
                                                    />
                                                );
                                            } else if (cell.column.Header === "Bill Invoice") {
                                                // NEW: open single bill invoice URL in preview; fetch by appointment_id if not present
                                                const rowData = cell.row.original;
                                                const invoiceUrl =
                                                    cell.row.values?.bill_invoice ??
                                                    rowData?.bill_invoice ??
                                                    cell.value;
                                                const hasInvoice =
                                                    Boolean(invoiceUrl) ||
                                                    Boolean(rowData?.appointment_id);

                                                data = (
                                                    <IconButton
                                                        icon={<Receipt size="16px" />}
                                                        aria-label="Open Bill Invoice"
                                                        size="md"
                                                        colorScheme="orange"
                                                        // isDisabled={!hasInvoice}
                                                        onClick={async (e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            await handleOpenInvoiceForRow(rowData);
                                                        }}
                                                        title={
                                                            hasInvoice
                                                                ? "Open Bill Invoice"
                                                                : "No invoice available"
                                                        }
                                                    />
                                                );
                                            } else if (cell.column.Header === "Prescription") {
                                                // NEW: Prescription column with custom cell rendering
                                                const rowData = cell.row.original;
                                                // Inject onPrescriptionClick callback into row data
                                                rowData.onPrescriptionClick = handlePrescriptionClick;
                                                data = cell.render("Cell");
                                            } else {
                                                // Default cell rendering, with an additional privacy check:
                                                // If the logged-in user is a frontdesk user and their id does not match
                                                // the appointment's frontdesk id, hide sensitive columns: SEX, AGE, MOBILE NO.
                                                // appointment's frontdesk id can be on different keys; try common ones
                                                // if isdoctor or isAdmin true Showblank is false if isFrontdesk then check for id does not match showblank true if null then showblank  is false

                                                let cellValue = cell.render("Cell");
                                                // console.log(cell.row?.original);
                                                try {
                                                    const userRaw = localStorage.getItem("user");
                                                    const currentUser = userRaw
                                                        ? JSON.parse(userRaw)
                                                        : null;

                                                    const isFrontdesk =
                                                        currentUser &&
                                                        (currentUser.role === "front_desk" ||
                                                            currentUser.role === "Frontdesk" ||
                                                            currentUser.role === "FRONTDESK");

                                                    const isDoctor =
                                                        currentUser &&
                                                        (currentUser.role === "doctor" ||
                                                            currentUser.role === "Doctor" ||
                                                            currentUser.role === "DOCTOR");
                                                    const isAdmin =
                                                        currentUser &&
                                                        (currentUser.role === "admin" ||
                                                            currentUser.role === "Admin" ||
                                                            currentUser.role === "ADMIN");
                                                    const appt = cell.row?.original || {};
                                                    const apptFrontdeskId =
                                                        appt.frontdesk_id ||
                                                        appt.frontdeskId ||
                                                        appt.front_desk_id ||
                                                        appt.front_desk_id ||
                                                        appt.front_desk ||
                                                        appt.frontdesk ||
                                                        null;

                                                    const currentUserId =
                                                        currentUser &&
                                                        (currentUser.id ||
                                                            currentUser.user_id ||
                                                            currentUser._id ||
                                                            null);

                                                    const isDifferentFrontdesk =
                                                        currentUserId &&
                                                        apptFrontdeskId &&
                                                        String(currentUserId) !== String(apptFrontdeskId);

                                                    let showBlank = isDoctor || isAdmin ? false : true;
                                                    if (isFrontdesk && isDifferentFrontdesk) {
                                                        showBlank = true;
                                                    }
                                                    if (isFrontdesk && !isDifferentFrontdesk) {
                                                        showBlank = false;
                                                    }
                                                    if (
                                                        showBlank &&
                                                        [
                                                            "SEX",
                                                            "AGE",
                                                            "mobile_no",
                                                            "MOBILE NO.",
                                                            "MOBILE NO",
                                                            "MOBILE NO.",
                                                            "MOBILE NO.",
                                                        ].includes(cell.column.Header.toUpperCase())
                                                    ) {
                                                        // render blank for mismatched frontdesk
                                                        cellValue = "";
                                                    }
                                                } catch (err) {
                                                    // If parsing localStorage fails, fall back to showing the cell value
                                                }

                                                data = (
                                                    <Text
                                                        color="gray.700"
                                                        fontWeight="500"
                                                        fontSize="14px"
                                                        lineHeight="1.4"
                                                    >
                                                        {cellValue}
                                                    </Text>
                                                );
                                            }

                                            return (
                                                <Td
                                                    {...cell.getCellProps()}
                                                    key={index}
                                                    fontSize="14px"
                                                    borderColor={borderColor}
                                                    textAlign="left"
                                                    width={
                                                        cell.column.width
                                                            ? `${cell.column.width}px`
                                                            : "auto"
                                                    }
                                                    minWidth={
                                                        cell.column.minWidth
                                                            ? `${cell.column.minWidth}px`
                                                            : "auto"
                                                    }
                                                    maxWidth={
                                                        cell.column.maxWidth
                                                            ? `${cell.column.maxWidth}px`
                                                            : "auto"
                                                    }
                                                    opacity={isCancelled ? 0.5 : 1}
                                                    color={isCancelled ? "gray.500" : "gray.700"}
                                                    fontWeight={isCancelled ? "400" : "500"}
                                                >
                                                    {data}
                                                </Td>
                                            );
                                        })}
                                    </Tr>
                                );
                            })}
                        </Tbody>
                    </Table>
                </Box>

                {/* Pagination controls */}
                <Flex justifyContent="space-between" m={4} alignItems="center">
                    <Flex>
                        <Button
                            onClick={() => gotoPage(0)}
                            disabled={!canPreviousPage}
                            mr={2}
                            size="sm"
                        >
                            {"<<"}
                        </Button>
                        <Button
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                            mr={2}
                            size="sm"
                        >
                            {"<"}
                        </Button>
                        <Button
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                            mr={2}
                            size="sm"
                        >
                            {">"}
                        </Button>
                        <Button
                            onClick={() => gotoPage(pageCount - 1)}
                            disabled={!canNextPage}
                            size="sm"
                        >
                            {">>"}
                        </Button>
                    </Flex>
                    <Flex alignItems="center">
                        <Text flexShrink="0" mr={8}>
                            Page{" "}
                            <Text fontWeight="bold" as="span">
                                {pageIndex + 1}
                            </Text>{" "}
                            of{" "}
                            <Text fontWeight="bold" as="span">
                                {pageOptions.length}
                            </Text>
                        </Text>
                        <Select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                            }}
                            width="100px"
                            size="sm"
                        >
                            {[4, 10, 20, 30, 40, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    Show {pageSize}
                                </option>
                            ))}
                        </Select>
                    </Flex>
                </Flex>
            </Box>
            {/* <EditPatientForm patientId= /> */}

            {/* Delete confirmation dialog */}
            <AlertDialog
                isOpen={isDeleteDialogOpen}
                leastDestructiveRef={cancelDeleteRef}
                onClose={cancelDelete}
                isCentered
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">Delete Patient</AlertDialogHeader>
                        <AlertDialogCloseButton />

                        <AlertDialogBody>
                            Are you sure you want to permanently delete <strong>{patientToDelete?.name}</strong> (ID: {patientToDelete?.patient_id ?? patientToDelete?.id})? This action cannot be undone.
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelDeleteRef} onClick={cancelDelete}>
                                Cancel
                            </Button>
                            <Button colorScheme="red" onClick={confirmDeletePatient} ml={3} isLoading={isDeleting}>
                                Delete
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <FilePreviewOverlay />
            {/* NEW: receipt list modal */}
            <ReceiptListModal />
            {/* Info modal for invoice/receipt messages */}
            <InfoModal />
            {/* NEW: Prescription modal */}
            <PrescriptionModal />

            <PaymentReceiptModal
                isOpen={isPaymentModalOpen}
                onClose={handlePaymentModalCloseWithRefresh}
                onPaymentConfirm={handlePaymentConfirm}
                patientName={selectedPaymentRow?.name}
                appointmentId={selectedPaymentRow?.id}
            />
            <BookAppointmentModal
                isOpen={isOpen}
                onClose={closeModal}
                onChange={handleInputChange}
                onBook={handleBookAppointment}
                billingSummary={billingSummary}
                onparametersChange={handleparametersChange}
                onGenerateBill={handleGenerateBill}
                newAppointmentData={newAppointmentData}
            />
            {selectedData && (
                <LabTestsModal
                    id={selectedData.id || selectedData.patient_id}
                    isOpen={isLabOpen}
                    onClose={closeLabModal}
                    userName={selectedData.name}
                />
            )}
            {selectedAppointmentData && (
                <PastAppoinmentModal
                    code={selectedAppointmentData.patient_code}
                    id={selectedAppointmentData.id}
                    isOpen={selectedAppointmentData && isPastAppointmentsOpen}
                    onClose={() => setIsPastAppointmentsOpen(false)}
                    userName={selectedAppointmentData.name}
                />
            )}
            {selectedData && (
                <ParametersModal
                    isOpen={isParametersOpen}
                    onClose={handleCloseParametersModal}
                    patientData={selectedData}
                    onChange={handleParametersChange}
                    doctor_id={selectedData.doctorId || doctorId}
                />
            )}
            {selectedAppointmentData && (
                <EditAppointmentModal
                    isOpen={isEditModalOpen}
                    onClose={() => {
                        setIsEditModalOpen(false);
                        setSelectedAppointmentData(null);
                        // reload the page on modal close to ensure latest data is reflected
                        try {
                            if (
                                typeof window !== "undefined" &&
                                window.location &&
                                typeof window.location.reload === "function"
                            ) {
                                window.location.reload();
                            }
                        } catch (err) {
                            console.error(
                                "Error reloading page on EditAppointmentModal close:",
                                err,
                            );
                        }
                    }}
                    appointment={selectedAppointmentData}
                    onUpdate={(updatedData) => {
                        // Update the table data with the edited appointment
                        const updatedTableData = tableData.map((item) =>
                            item.id === updatedData.appointment_id
                                ? { ...item, ...updatedData }
                                : item,
                        );

                        // Check if setTableDataComplex is a function before calling it
                        if (typeof setTableDataComplex === "function") {
                            setTableDataComplex(updatedTableData);
                        } else {
                            console.warn(
                                "setTableDataComplex is not a function in EditAppointmentModal onUpdate:",
                                typeof setTableDataComplex,
                            );
                        }
                    }}
                />
            )}
            {/* NEW: EditPatientForm overlay */}
            {isEditPatientOpen && (
                <EditPatientForm
                    isOpen={isEditPatientOpen}
                    onClose={handleCloseEditPatient}
                    patientId={
                        selectedPatientForEdit?.id || selectedPatientForEdit?.patient_id
                    }
                    patientData={selectedPatientForEdit}
                    onUpdate={(updatedPatient) => {
                        // Update the table data when patient is edited
                        const updatedTableData = tableData.map((item) => {
                            // match by id or patient_id
                            const matchId =
                                (item.id &&
                                    selectedPatientForEdit &&
                                    item.id ===
                                    (selectedPatientForEdit.id ||
                                        selectedPatientForEdit.patient_id)) ||
                                (item.patient_id &&
                                    selectedPatientForEdit &&
                                    item.patient_id ===
                                    (selectedPatientForEdit.id ||
                                        selectedPatientForEdit.patient_id));
                            if (matchId) {
                                return { ...item, ...updatedPatient };
                            }
                            return item;
                        });

                        if (typeof setTableDataComplex === "function") {
                            setTableDataComplex(updatedTableData);
                        } else {
                            console.warn(
                                "setTableDataComplex is not a function:",
                                typeof setTableDataComplex,
                            );
                        }

                        toast({
                            title: "Patient updated",
                            description: `${updatedPatient.name || "Patient"
                                } updated successfully`,
                            status: "success",
                            duration: 3000,
                            isClosable: true,
                        });

                        // close overlay
                        handleCloseEditPatient();
                    }}
                />
            )}
        </Card>
    );
}

